<div fxLayout="row" fxLayoutAlign="space-between top">
  <span mat-dialog-title>{{ 'absences.absence' | translate }}</span>
  <button mat-icon-button matDialogClose>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<form [formGroup]="absenceForm" appReadOnlyWithoutPermission="WRITE_ABSENCES" (ngSubmit)="persistAbsence()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>{{ 'absences.startDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="startDatePicker" formControlName="startDate">
      <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'absences.endDate' | translate }}</mat-label>
      <input matInput [matDatepicker]="endDatePicker" formControlName="endDate">
      <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field>
      <mat-label>{{ 'absences.class' | translate }}</mat-label>
      <mat-select placeholder="{{ 'absences.class' | translate }}" formControlName="class">
        @for (absenceClass of absenceClasses$ | async; track absenceClass) {
          <mat-option [value]="absenceClass.id">
            {{ absenceClass.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-raised-button *ngxPermissionsOnly="['WRITE_ABSENCES']" color="accent" type="submit" [disabled]="absenceForm.invalid">
      <mat-icon>check</mat-icon>
      {{ 'absences.actions.persist' | translate }}
    </button>
  </mat-dialog-actions>
</form>
